module.exports = __webpack_public_path__ + "img/icom7.441e78d6.png";